import Swiper from "swiper"

export default new (class BaristaSchoolCarousel {
    constructor() {
        this.sliderContainerSelector = "carousel-baristaschool"
        this.carousel = undefined
        this.handler()
    }

    handler() {
        const slider = document.querySelector(`.${this.sliderContainerSelector}`)

        if (!slider) return

        document.addEventListener("DOMContentLoaded", () => {
            this.init()
        })
        window.addEventListener("resize", () => {
            this.init()
        })
    }

    init() {
        document.querySelectorAll(`.${this.sliderContainerSelector}`).forEach((item) => {
            let mobile = window.matchMedia('(min-width: 0px) and (max-width: 767px)');
            // Enable (for mobile)
            if(mobile.matches) {
                if (item.classList.contains('swiper-initialized')) return;
                this.carousel = new Swiper(item, {
                    slidesPerView: 1.2,
                    spaceBetween: 8,
                    centerInsufficientSlides: true,
                    breakpoints: {
                        300: {
                            slidesPerView: 1.2,
                        },
                        576: {
                            slidesPerView: 2.2,
                            spaceBetween: 16,
                        },
                    },
                })
            }
            else {
                if ( this.carousel !== undefined ) {
                    this.carousel.destroy(true, true);
                }
            }

        })
    }
})()
